import React from "react";
import pool1 from "../assets/images/pool/pool1.png";
import pool2 from "../assets/images/pool/pool2.png";
import pool3 from "../assets/images/pool/pool3.png";
import poolInfo1 from "../assets/images/pool/pool_info_pvc.png";
import poolInfo2 from "../assets/images/pool/pool_info_framework.png";
import poolInfo3 from "../assets/images/pool/pool_info_flame.png";

function Pool() {
  const poolImages = [
    {
      src: pool1,
      title: "사각 수영장",
      description: "견고하고 안전한 프레임 구조의 대중적인 직사각형 디자인",
    },
    { src: pool2, title: "원형 수영장", description: "설치가 간편하고 공간 효율이 뛰어난 곡선형 디자인" },
    { src: pool3, title: "골조 수영장", description: "대형 스케일과 전문적인 수영을 위한 고강도 골조 구조" },
  ];

  const infoImages = [
    {
      src: poolInfo1,
      title: "고강도 PVC 원단",
      description: `1. 외부 박판 가공층

폴리비닐 클로라이드 (PVC sheet)
자외선 차단을 역저리 (UV처리)
항균, 항곰 방지 처리

2. 외부 박피 코팅층

폴리비닐 클로라이드 (PVC Dipping)
접합처리 연결코팅

3. 폴리에스터 코어 가공층

100% 폴리에스터 원사 가공
1000Denier 연사 가공

4. 내부 박피 코팅층

폴리비닐 클로라이드 (PVC Dipping)
접합처리 연결코팅`,
    },
    {
      src: poolInfo2,
      title: "안정적 Framework",
      description: `1. 50.8m/m x 1.8t posco HGI 강관
	 • 	 염소 표백 가공

2. 고온 도금 처리
	 • 	 항산화 방지처리 가공

3. 직류전기를 통한 아연 도금 코팅처리
	 • 	 ASTM B633 Type Class 3

4. 고압 분체 도장처리
	 • 	 1회 분사후, 2회 격막도장분체 처리

5. 제조사
	 • 	 포항 제철`,
    },
    { src: poolInfo3, title: "방청 프레임", description: "부식 방지 처리가 된 아연 도금 강관 프레임" },
  ];

  const specRows = [
    ["2.8 × 4", "1.2 / 0.9 / 0.7", "3.4", "12.3", "3~7"],
    ["2.8 × 5.2", "1.2 / 0.9 / 0.7", "4.3", "15.4", "6~9"],
    ["2.8 × 6.4", "1.2 / 0.9 / 0.7", "5.2", "19.0", "8~10"],
    ["4 × 6.4", "1.2 / 0.9 / 0.7", "7.8", "28.2", "12~16"],
    ["4 × 7.6", "1.2 / 0.9 / 0.7", "9.2", "33.4", "14~18"],
    ["5.2 × 7.6", "1.2 / 0.9 / 0.7", "12.0", "43.5", "18~24"],
    ["5.2 × 8.8", "1.2 / 0.9 / 0.7", "13.9", "50.3", "21~28"],
  ];

  const largeSpecRows = [
    ["6.4 × 10", "1.2 / 0.9 / 0.7", "19.4", "70.4", "29~39"],
    ["7.6 × 13.6", "1.2 / 0.9 / 0.7", "31.3", "113.7", "47~63"],
    ["10 × 15", "1.2 / 0.9 / 0.7", "45.5", "165.0", "68~91"],
    ["10 × 20", "1.2 / 0.9 / 0.7", "60.6", "220.0", "91~121"],
    ["15 × 20", "1.2 / 0.9 / 0.7", "90.9", "330.0", "136~182"],
    ["20 × 30", "1.2 / 0.9 / 0.7", "181.8", "660.0", "273~364"],
    ["30 × 45", "1.2 / 0.9 / 0.7", "409.1", "1485.0", "614~818"],
  ];

  return (
    <section id="pool" className="section-padding bg-slate-50">
      <div className="container mx-auto px-6">
        <header className="max-w-3xl mx-auto text-center mb-20">
          <h2 className="text-sm font-bold text-blue-600 uppercase tracking-[0.3em] mb-4">Our Products</h2>
          <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 tracking-tight">
            맞춤형 수영장 솔루션
          </h1>
          <p className="text-lg text-slate-600 leading-relaxed font-light">
            골조 수영장부터 이동식 수영장까지, 공간의 제약을 넘어 <br className="hidden md:block" />
            최상의 워터 라이프를 위한 최적의 설비를 제안합니다.
          </p>
        </header>

        {/* Pool Types Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-32">
          {poolImages.map((image, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl overflow-hidden premium-shadow transition-all duration-500 hover:-translate-y-2"
            >
              <div className="relative h-72 overflow-hidden">
                <div className="absolute inset-0 bg-blue-600/10 group-hover:bg-blue-600/0 transition-colors duration-500 z-10" />
                <img
                  src={image.src}
                  alt={image.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-8">
                <h4 className="text-2xl font-bold text-slate-900 mb-3">{image.title}</h4>
                <p className="text-slate-500 leading-relaxed font-light">{image.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Technical Details */}
        <div className="mb-32">
          <div className="max-w-xl mb-12">
            <h3 className="text-sm font-bold text-blue-600 uppercase tracking-widest mb-4">
              Technical Details
            </h3>
            <h2 className="text-4xl font-black text-slate-900 mb-6">최고의 기술력과 내구성</h2>
            <p className="text-lg text-slate-600 font-light leading-relaxed">
              오랜 시간 안전하게 사용할 수 있도록 검증된 소재와 구조적 안정성을 최우선으로 합니다.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {infoImages.map((image, index) => (
              <div
                key={index}
                className="group flex flex-col p-5 rounded-[2.5rem] bg-white border border-slate-50 premium-shadow transition-all duration-500 hover:-translate-y-2"
              >
                <div className="rounded-[1.8rem] overflow-hidden bg-white mb-8">
                  <img
                    src={image.src}
                    alt={image.title}
                    className="w-full h-auto object-contain transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="px-4 pb-4">
                  <h4 className="text-2xl font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors">
                    {image.title}
                  </h4>
                  <p className="text-base text-slate-500 leading-relaxed font-light whitespace-pre-line">
                    {image.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Specifications Table */}
        <div className="bg-slate-900 rounded-[3rem] p-8 md:p-16 text-white overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-blue-600/20 blur-[120px] rounded-full -mr-32 -mt-32" />
          <div className="relative z-10">
            <h3 className="text-3xl font-bold mb-12 text-center">제품 규격 데이터</h3>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              {/* Type 1: Standard */}
              <div>
                <h4 className="text-xl font-bold text-blue-400 mb-6 flex items-center">
                  <span className="w-8 h-px bg-blue-400 mr-3"></span>
                  일반형 규격
                </h4>
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm">
                    <thead>
                      <tr className="border-b border-white/10">
                        <th className="py-4 font-medium text-slate-400 uppercase tracking-wider">규격 (m)</th>
                        <th className="py-4 font-medium text-slate-400 uppercase tracking-wider">
                          높이 옵션
                        </th>
                        <th className="py-4 font-medium text-slate-400 uppercase tracking-wider">평</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-white/5">
                      {specRows.slice(0, 6).map((row, i) => (
                        <tr key={i} className="hover:bg-white/5 transition-colors">
                          <td className="py-4 font-bold">{row[0]}</td>
                          <td className="py-4 text-slate-300 font-light">{row[1]}</td>
                          <td className="py-4 text-blue-400 font-bold">{row[2]}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Type 2: Large */}
              <div>
                <h4 className="text-xl font-bold text-blue-400 mb-6 flex items-center">
                  <span className="w-8 h-px bg-blue-400 mr-3"></span>
                  대형 규격
                </h4>
                <div className="overflow-x-auto">
                  <table className="w-full text-left text-sm">
                    <thead>
                      <tr className="border-b border-white/10">
                        <th className="py-4 font-medium text-slate-400 uppercase tracking-wider">규격 (m)</th>
                        <th className="py-4 font-medium text-slate-400 uppercase tracking-wider">
                          높이 옵션
                        </th>
                        <th className="py-4 font-medium text-slate-400 uppercase tracking-wider">평</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-white/5">
                      {largeSpecRows.slice(0, 6).map((row, i) => (
                        <tr key={i} className="hover:bg-white/5 transition-colors">
                          <td className="py-4 font-bold">{row[0]}</td>
                          <td className="py-4 text-slate-300 font-light">{row[1]}</td>
                          <td className="py-4 text-blue-400 font-bold">{row[2]}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <p className="mt-12 text-center text-slate-500 text-sm font-light">
              * 위 규격 외 맞춤 제작이 가능합니다. 상세 문의는 고객센터로 연락 바랍니다.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Pool;
